import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createVuetify, createRouter, createI18n, setErrorHandlers } from '@core';
import { createAuthGuard } from '@shared';
import routes from './app/routes';
import themes from './app/themes';
import messages from './i18n';
import App from './App.vue';
import 'vue3-openlayers/dist/vue3-openlayers.css';
import './assets/scss/styles.scss';
import { initForms } from './app/modules/offer-calculator/utils/validator.utils';

const app = createApp(App);
setErrorHandlers(app);

const pinia = createPinia();
const router = createRouter(routes);
const i18n = createI18n('hu', messages);
const vuetify = createVuetify(
  i18n,
  themes,
  {
    VTextField: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary'
    }
  },
  'dark'
);

initForms();

app.use(pinia);

createAuthGuard(router, 'login');

app.use(router);
app.use(i18n);
app.use(vuetify);
app.mount('#app');
